//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service'
import ServiceChat from '@/service/chat_list'
import ConsultantService from '@/service/consultant'

import IM, { IM_STORE } from '@/data/im'
import { App_User } from '@/data/user_info'

import ChatItem from './_item'

import { getMixin } from '@/common/tpl/im/im_login'

import unread from './_base/unread_mixin'

import Unread from './_base/unread'
import UnreadList from './_base/unread_list'

import { Dialog } from 'vant'

const KEY = 'chat_list'

let task

const CATEGORIES_TYPES = {
    '开盘消息': {
        key: 'open',
        name: '开盘消息',
        order: 0

    },
    '互动消息': {
        key: 'interac',
        name: '互动消息',
        order: 1

    },
    '活动消息': {
        key: 'act',
        name: '通通速递',
        order: 2
    }
}


const TOP_TABS_TYPE = {
    "邀请评论": "invite",
    "置业顾问通知": "con",
    "收到的回复": "reply",
    "收到的点赞": "give_like",
    "最新动态": "events"
}

export default {
    mixins: [
        unread,
        getMixin({
            page_key: KEY
        })
    ],
    name: KEY,
    data () {
        return {
            show_login: false,
            page: 1,
            loading: true,
            list_loading: true,
            is_login: IM_STORE.login,
            chats: [],
            is_consultant_user: false,
            notice: {
                desc: ''
            },
            hot_list: [],
            hot_time: '',
            no_more: false,
            categories: [],
            top_tabs: [],
            is_refresh: false,
            scroll_id: 'top_tabs',
            enable_scroll: true,
            move_index: -1
        }
    },
    beforeRouteEnter (to, from, next) {
        next((vm) => {
            vm.initImLogin()
            vm.init()
        })
    },
    mounted () {
    },
    watch: {
        is_login (isLogin) {
            if (isLogin) {
                wx.hideLoading()
            }
        },
        no_more (no_more) {
            if (no_more) {
                ConsultantService.getHotSearchList().then(data => {
                    this.hot_list = data.items
                    this.hot_time = data.refreshed_at
                })
            }
        }
    },
    beforeDestroy () {
        IM_STORE.remove_page_watcher(KEY)
        IM_STORE.remove_chatList_watcher(KEY)
        IM_STORE.remove_no_more_watcher(KEY)
        task && clearTimeout(task)
    },
    methods: {
        init () {
            if (!this.is_login) {
                wx.showLoading({
                    title: '请稍等',
                    mask: true
                })
            }
            Service.init().then(() => {
                App_User.fetchUser().then(({ is_consultant, tag_list }) => {
                    this.is_consultant_user = is_consultant
                    this.show_login = tag_list[0] == "天府通游客"
                    if (this.show_login) {
                        Dialog.confirm({
                            title: '提示',
                            message: '您还未登录，请先登录',
                        }).then(() => {
                            wx.navigateTo({
                                url: '/logging_in'
                            })
                        }).catch(() => {
                            this.$router.replace({ name: 'Home' })
                        })
                        return
                    }
                    if (!this.list_loading) {
                        this.page = 1
                        this.getSessions()
                    }
                    this.initTabs()
                    this.addListener()
                })
            })
        },
        reachBottom () {
            if (!this.list_loading && !this.no_more) {
                this.page += 1
                this.getSessions()
            }
        },
        disableScroll (move_index) {
            this.enable_scroll = false
            this.move_index = move_index
        },
        enableScroll () {
            this.enable_scroll = true
        },
        refresh () {
            this.is_refresh = true
            if (!this.list_loading) {
                this.page = 1
                this.getSessions()
                this.initTabs()
                this.getNewMessageLen()
            }
            task = setTimeout(() => {
                this.is_refresh = false
            }, 1000)
        },
        async initTabs() {
            const data = await ServiceChat.getChatListCategories()
            const exclude_names = ['微聊消息']

            const messages_tabs = data.items
                .reduce((prev, item) => {
                    const { name } = item
                    if (name === '置顶消息') {
                        prev.push(...item.tabs)
                    } else {
                        prev.push(item)
                    }
                    return prev
                }, [])
                .filter(({ name }) => exclude_names.indexOf(name) === -1)

            this.top_tabs = messages_tabs
                .filter(({ name }) => TOP_TABS_TYPE[name])
                .map((item) => {
                    item.key = TOP_TABS_TYPE[item.name]
                    let link = `/list/message_list/list?category=置顶消息&tab_name=${item.name}`
                    if (item.key === 'events') {
                        link = `/pages/list/dynamic/main`
                    }
                    return {
                        ...item,
                        link
                    }
                })

            this.categories = messages_tabs
                .filter(({ name }) => CATEGORIES_TYPES[name])
                .map(item => {
                    if (item.tabs) {
                        item.tabs.some(({ unread_count, name }) => {
                            if (unread_count > 0) {
                                item.tab_name = name
                                return true
                            }
                        })
                    }
                    const category = CATEGORIES_TYPES[item.name]
                    console.log('tab_name', item, item.name, category)
                    let category_type = item.name
                    if(item.name === '开盘消息'){
                        item.tab_name = item.last_message.name
                    }
                    let tab_name = item.tab_name
                    if (item.name === '活动消息') {
                        category_type = '置顶消息'
                        tab_name = '活动消息'
                    }
                    const link = `/list/message_list/list?category=${category_type}&tab_name=${tab_name}`
                    return {
                        ...item,
                        tab_name: item.tab_name || category.name,
                        key: category.key,
                        link,
                        order: category.order
                    }
                })
                .sort((a, b) => {
                    return a.order - b.order
                })
        },

        getSessions () {
            this.list_loading = true
            console.error('_____________getSession_____________', this.page)
            IM.getSessions({
                page: this.page
            })
        },
        addListener () {
            this.addLoginListener()
            IM_STORE.add_page_watcher(KEY, page => {
                console.error('page change', page)
                this.page = page
            })
            IM_STORE.add_chatList_watcher(KEY, (chatList) => {
                console.error('_____________________', chatList.length)
                this.chats = chatList
                this.list_loading = false
                if (this.page === 1) {
                    if (this.is_refresh) {
                        return
                    }
                    this.scroll_id = ''
                    this.$nextTick(() => {
                        this.scroll_id = 'top_tabs'
                    })
                }
            })
            IM_STORE.add_chatListLoaded_watcher(KEY, (loaded) => {
                this.loading = !loaded
            })
            IM_STORE.add_no_more_watcher(KEY, (no_more) => {
                console.error('_____________________no_more', no_more)
                this.no_more = no_more
            })
            IM_STORE.add_session_loading_watcher(KEY, (session_loading) => {
                this.session_loading = session_loading
            })
            IM_STORE.add_page_watcher(KEY, (page) => {
                this.page = page
            })
        },
        async readAll () {
            const { unread_message_counts } = await App_User.fetchUser()
            console.error('readAll', unread_message_counts)
            if (unread_message_counts && (unread_message_counts.unread_count || unread_message_counts.has_new_message)) {
                Service.readAllTimMsg()
                ServiceChat.readAllUserMessages().then(this.initTabs)
                IM.getSessions()
                IM.readAll()
            } else {
                wx.showToast({
                    title: '暂无未读消息',
                    icon: 'none'
                })
            }
        }
    },
    components: {
        Dialog,
        ChatItem,
        Unread,
        UnreadList,
    }
}
